import {Grid, Typography} from "@material-ui/core";
import {shallowEqual, useSelector} from "react-redux";
import TopOfferItem from "../top-offer-item/TopOfferItem";
import WhiteHeaderCard from "../../../../../../components/ui/cards/white-header-card/WhiteHeaderCard";
import MainOfferContent from "../main-offer-content/MainOfferContent";
import TokenOptionsTable from "../../../../tables/token-options-table/TokenOptionsTable";
import React from "react";

const NewOffer = (props) => {
    const newOffer = useSelector(state => state.digitalContractReducer.planOptionsForSim.selectedPlanOffer, shallowEqual)

    return (
        <>
            <WhiteHeaderCard loading={newOffer.loading}>
                {/*Create items above the main zone offer*/}
                <Grid container
                      spacing={3}>
                    {newOffer.data.offertaTopItemList.map((item, index) => {
                        // {tempTopItems.map((item, index) => {
                        return (
                            <Grid item
                                  key={"offer-top-item-" + index}
                                  xs={12} sm={6} md={6}>
                                <TopOfferItem item={item}/>
                            </Grid>
                        )
                    })}
                </Grid>
                {/*Create the main part of the offerta with zones*/}
                <MainOfferContent zoneData={newOffer.data.offertaZoneItemList}
                                  planName={newOffer.data.planName}/>
                {props.isFromDC ?
                    <Typography variant={"subtitle1"}>Opzioni e gettoni attivi</Typography> : null}
                {/*Create token options table*/}
                <TokenOptionsTable data={newOffer.data.opzioniGettoniDtoList}/>
            </WhiteHeaderCard>

        </>
    )
}

export default NewOffer;
